<template>
  <div id="operationsContainer" v-uploader="dropFileHandler">
    <div v-if="ifhuishou != '回收站'" class="left">
      <el-button v-if="addXtDesign && isShowAddFolder && fileShow" size="small" type="primary" icon="el-icon-plus" @click="addFolder"> 新建文件夹 </el-button>
      <el-dropdown v-if="uploadXtDesign && isShowUploader && isMoveCopy && fileShow" trigger="click" placement="bottom-start" @command="isFileOrFolder">
        <el-button size="small" type="primary" class="upload" plain icon="el-icon-upload2"> 上传 </el-button>
        <el-dropdown-menu slot="dropdown" style="width: 94px">
          <el-dropdown-item v-if="isShowUploader" command="file" style="text-align: center !important"> 文件 </el-dropdown-item>
          <!-- 上传文件夹同新建文件夹的权限 -->
          <el-dropdown-item v-if="isShowUploader" command="folder" style="text-align: center !important"> 文件夹 </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-if="downDesign && isDownFolder" size="small" type="primary" plain icon="el-icon-download" @click="batchDownload"> 下载 </el-button>
      <el-button v-if="shareXtDesign && fileShow" size="small" type="primary" plain icon="el-icon-share" @click="batchShare"> 分享 </el-button>
      <el-button v-if="deleXtDesign && isDownFolder && fileShow" size="small" type="danger" plain icon="el-icon-delete" @click="batchDel"> 删除 </el-button>
      <el-button v-if="isMoveCopy && fileShow" size="small" type="primary" plain icon="el-icon-rank" @click="moveBtn"> 移动到 </el-button>
      <el-button v-if="isMoveCopy && fileShow" size="small" type="primary" plain icon="el-icon-document-copy" @click="copyBtn"> 复制到 </el-button>
      <el-button v-if="selectArr && isShowAddModel && isRvtSkp && fileShow" size="small" type="primary" @click="addModel"> 添加至整合模型 </el-button>
      <component :is="dynamicButtons"></component>
    </div>
    <div v-else>
      <el-button size="small" type="primary" :disabled="resumeShow" @click="thoroughDeleteOrRecover(2)"> 恢复 </el-button>
      <el-button v-if="deleCompletely" size="small" type="danger" @click="thoroughDeleteOrRecover(1)"> 彻底删除 </el-button>
    </div>
    <div class="search">
      <el-badge v-if="ifhuishou != '回收站' && fileShow" :value="integrationValue" :hidden="integrationValue > 0 ? false : true">
        <el-button type="primary" size="small" @click="clickModel"> 待整合模型 </el-button>
      </el-badge>
      <el-button v-if="ifhuishou != '回收站' && fileShow" class="rightBtn" type="primary" size="small" plain @click="openIntegrationRecord"> 整合记录 </el-button>
      <el-input
        v-model.trim="searchValue"
        :placeholder="searchTiTle"
        :suffix-icon="!searchValue ? 'el-icon-search' : ''"
        :clearable="Boolean(searchValue)"
        type="text"
        style="height: 100%; cursor: pointer"
        size="small"
        maxlength="20"
      >
      </el-input>
    </div>
    <moveCopy v-if="moveCopyShow" ref="moveCopy" :title="moveCopyTitle" @callback="refreshTable"></moveCopy>
    <IntegrationRecord ref="IntegrationRecord" />
  </div>
</template>
<script>
import operations from "@/CommonDP/pages/mainMg/project/document/rightMain/operations/operations.backup.vue";
import { mapState } from "vuex";
import zipService from "@/xgzdService/zip-service";
import { downloadBlob } from "@/utils";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
export default {
  extends: operations,
  computed: {
    ...mapState({
      zipList: (state) => state.zip.zipList,
      enterprise: (state) => state.enterprise,
      navArr: (state) => state.XtDesign.navArr
    }),
    fileShow() {
      //归档不显示对应文件夹  只显示下载
      if (this.navArr && this.navArr.length > 0 && this.navArr[0]?.folderType == 2) return false;
      else return true;
    }
  },
  methods: {
    batchDownload() {
      if (this?.zipList && this?.zipList?.length > 0) return this.$message.warning("有正在压缩等待下载的文件夹，请稍等");
      const { selectArr } = this;
      const userInfo = this.userInfo;
      const isRead = selectArr.some((item) => item.isRead === 1 || item.isRead === 0);
      const { token } = userInfo;
      if (selectArr.length === 0) return this.$message.warning("请选择文件");
      if (isRead) {
        return this.$message.warning("您选择的文件中包含没有下载权限的文件，请重新选择");
      }
      const isFolder = selectArr.some((item) => item.isFolder === 1);

      const prjId = this.prjInfo.prjId;
      const files = selectArr.filter((item) => item.isFolder !== 1);
      const folders = selectArr.filter((item) => item.isFolder === 1);
      // 存在文件夹 下载文件夹
      if (isFolder && folders.length > 0) {
        let zipName = folders[0].folderName;
        if (folders.length > 1) {
          zipName += `等${folders.length}个文件夹`;
        }
        const zipItem = {
          name: zipName + ".zip",
          percent: 0,
          success: false
        };
        this.$store.dispatch("pushZip", zipItem);
        const params = {
          folderIdList: folders.map((it) => it.folderId),
          prjId: this.prjInfo.prjId,
          userId: userInfo.userId,
          enterpriseId: this.enterprise.enterpriseId
        };
        zipService
          .batchDownloadFolder(params, (percentage) => {
            zipItem.percent = percentage;
          })
          .then((response) => {
            const fileName = zipName + ".zip";
            zipItem.success = true;
            this.$store.dispatch("refreshZip");
            downloadBlob(response, fileName);
          });
      }
      // 存在文件 则下载文件
      if (files && files.length > 0) {
        const urls = files.map((item) => {
          return downloadUrltoken(prjId, item.folderId, item.fileVersion);
        });
        for (let i = 0; i < urls.length; i++) {
          downloadFile(urls[i]);
        }
      }
    },
    // 移除基础平台对空格的限制
    addFolder() {
      const { folderId } = this.currentNode.data;
      this.$prompt("", "新建文件夹", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入文件夹名称",
        // inputPattern: /^\S*$/,
        // inputErrorMessage: "文件夹名称不能包含空格",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        inputValidator: (value) => {
          if (!value) {
            return "文件夹名称不能为空";
          }
          if (value.length > 80) {
            return "文件夹名称不能大于80个字符";
          }
          var regExp = new RegExp('[\\\\|/:*<>?"]');
          if (regExp.test(value)) {
            return '文件夹名称不能包含以下字符:\\ / : * " ? < > |';
          }
          this.val = value;
        },
        beforeClose: async (action, instance, done) => {
          debugger;
          if (action === "confirm") {
            this.$store.dispatch("XtDesignUpdateMessageObj", {
              isShow: true,
              message: "新建中..."
            });
            const { prjId: prjId } = this.prjInfo;
            const parentId = folderId;
            const folderName = this.val.trim();
            const data = { parentId, folderName, prjId };
            try {
              const result = await docService.queryAddFolder(data);
              if (result.result === "0") {
                await this.$store.dispatch("XtDesignUpdateNodeList");
                this.$store.dispatch("XtDesignUpdateMessageObj", {
                  isShow: false
                });
                this.$message.success("新建成功");
                done();
              }
            } catch (e) {
              console.error(e);
              this.$store.dispatch("XtDesignUpdateMessageObj", { isShow: false });
            }
          } else {
            done();
          }
        }
      }).catch((e) => {
        console.error(e);
      });
    },
    async dropFileHandler(files, cb) {
      const opts = this.uploaderOpts;
      if (this.uploadXtDesign && this.isShowUploader && this.isMoveCopy && this.fileShow) {
        await cb(files, opts);
        this.refresh();
      }
    }
  }
};
</script>